/* Attention: this file is auto-generated by xingdesigntool */
module.exports = {
  scale005: '1px',
  scale010: '2px',
  scale020: '4px',
  scale030: '6px',
  scale040: '8px',
  scale050: '10px',
  scale060: '12px',
  scale070: '14px',
  scale080: '16px',
  scale090: '18px',
  scale100: '20px',
  scale110: '24px',
  scale120: '28px',
  scale130: '32px',
  scale140: '36px',
  scale150: '42px',
  scale160: '48px',
  scale170: '54px',
  scale180: '60px',
  scale190: '68px',
  scale200: '76px',
  scale210: '84px',
  scale220: '92px',
  scale230: '102px',
  scale240: '112px',
  scale250: '122px',
  scale260: '132px',
  scale270: '144px',
  scale280: '156px',
  scale290: '168px',
  scale300: '180px',
  scale310: '194px',
  scale320: '208px',
  scale330: '222px',
  scale340: '236px',
  scale350: '252px',
  scale360: '268px',
  scale370: '284px',
  scale380: '300px',
  scale390: '318px',
  scale400: '336px',
  scale410: '354px',
  scale420: '372px',
  scale430: '392px',
  scale440: '412px',
  scale450: '432px',
  spaceXXS: '2px',
  spaceXS: '4px',
  spaceS: '8px',
  spaceM: '12px',
  spaceL: '16px',
  spaceXL: '24px',
  spaceXXL: '32px',
  xdlColorBackground: '#FFFFFF',
  xdlColorBackgroundSecondary: '#F9FAFA',
  xdlColorBackgroundTertiary: '#F4F4F5',
  xdlColorBorder: '#BCC9D1',
  xdlColorBorderSoft: '#DBE2E6',
  xdlColorBorderStrong: '#1D2124',
  xdlColorCaution: '#FFA000',
  xdlColorControlBorder: '#BCC9D1',
  xdlColorControlBorderSecondary: '#1D2124',
  xdlColorControlBorderTertiary: '#FFFFFF',
  xdlColorControlFill: '#FFFFFF',
  xdlColorControlFillQuaternary: '#1D2124',
  xdlColorControlFillSecondary: '#F4F4F5',
  xdlColorControlFillTertiary: '#DBE2E6',
  xdlColorDisabled: '#DBE2E6',
  xdlColorDisabledSoft: '#E9EEF0',
  xdlColorDisabledStrong: '#BCC9D1',
  xdlColorError: '#F33A58',
  xdlColorErrorSoft: '#FDEBEE',
  xdlColorFocussed: '#009090',
  xdlColorGo: '#4DB86B',
  xdlColorHighlighted: '#C6F16D',
  xdlColorHover: '#F4F4F5',
  xdlColorHoverDark: '#BCC9D1',
  xdlColorInfo: '#68C3FC',
  xdlColorInfoSoft: '#EFF9FE',
  xdlColorLink: '#009090',
  xdlColorLinkHover: '#007575',
  xdlColorLinkVisited: '#728895',
  xdlColorNew: '#68C3FC',
  xdlColorPremium: '#199980',
  xdlColorPremiumSecondary: '#00D296',
  xdlColorPremiumTertiary: '#007875',
  xdlColorPricing: '#9C195B',
  xdlColorPrimaryButtonHover: '#B5DA67',
  xdlColorSelected: '#1D2124',
  xdlColorSelectedSecondary: '#009090',
  xdlColorSelectedTertiary: '#BFDCDC',
  xdlColorStop: '#F33A58',
  xdlColorSuccess: '#4DB86B',
  xdlColorSuccessSoft: '#CFF1D8',
  xdlColorText: '#1D2124',
  xdlColorTextOnDark: '#FFFFFF',
  xdlColorTextOnLight: '#1D2124',
  xdlColorTextSecondary: '#5E737D',
  xdlColorTextSecondaryOnDark: '#8A9DA6',
  xdlColorTextSecondaryOnLight: '#5E737D',
  xdlColorTextTertiary: '#8A9DA6',
  xdlColorTextTertiaryOnDark: '#5E737D',
  xdlColorTextTertiaryOnLight: '#8A9DA6',
  xdlColorUnseen: '#FFA000',
  xdlColorXING: '#C6F16D'
};
